<div class="block-column">
  <div class="element-column">
    <div class="column-list">
      <div class="list-input-title">ページテンプレート名</div>
      <div class="list-input-content">
        <input type="text" id="txti_PageTemplateName" style="width:25rem;"
          [style.text-align]="'left'" readonly [maxlength]="25"
          [(ngModel)]="editPageData.PageTemplateName">
      </div>

      <div class="list-input-title">ページ領域始点X(mm)</div>
      <div class="list-input-content">
        <input type="text" style="width:8rem;"
          id="txti_PageAreaX" plessInputTextSub [restrict]="'[0-9.]'" [maxlength]="5"
          readonly [ngModel]="editPageData.PageAreaX" (ngModelChange)="editPageData.PageAreaX=$event">
      </div>

      <div class="list-input-title">ページ領域始点Y(mm)</div>
      <div class="list-input-content">
        <input type="text" style="width:8rem;"
          id="txti_PageAreaY" plessInputTextSub [restrict]="'[0-9.]'" [maxlength]="5" 
          readonly [ngModel]="editPageData.PageAreaY" (ngModelChange)="editPageData.PageAreaY=$event">
      </div>

      <div class="list-input-title">ページ領域幅(mm)</div>
      <div class="list-input-content">
        <input type="text" style="width:8rem;"
          id="txti_PageAreaWidth" plessInputTextSub [restrict]="'[0-9.]'" [maxlength]="5"
          readonly [ngModel]="editPageData.PageAreaWidth" (ngModelChange)="editPageData.PageAreaWidth=$event">
      </div>

      <div class="list-input-title">ページ領域高さ(mm)</div>
      <div class="list-input-content">
        <input type="text" style="width:8rem;"
          id="txti_PageAreaHeight" plessInputTextSub [restrict]="'[0-9.]'" [maxlength]="5"
          readonly [ngModel]="editPageData.PageAreaHeight" (ngModelChange)="editPageData.PageAreaHeight=$event">
      </div>

      <div class="list-input-title">グリッド</div>
      <div class="list-input-content">
        <label>横</label>
        <wj-input-number class="numeric-stepper"
          #SectionDivW id="ns_PageDivW" [min]="1" [max]="99" [style.text-align]="'left'" 
          [showSpinner]="true" [step]="1" [disabled]="true" [value]="1" [isRequired]="false"
          [(ngModel)]="editPageData.DivW">
        </wj-input-number>
        <label>×</label>
        <label>縦</label>
        <wj-input-number class="numeric-stepper"
          #SectionDivH id="ns_PageDivH" [min]="1" [max]="99"
          [showSpinner]="true" [step]="1" [disabled]="true" [value]="1" [isRequired]="false"
          [(ngModel)]="editPageData.DivH">
        </wj-input-number>
      </div>
    </div>
  </div>
  <button class="btn-secondary"
    id="btn_NewSectionCreate" (click)="clickNewSectionCreate.emit()">セクションを追加</button>
</div>
